<button color="primary" (click)="consultarAyuda()" mat-icon-button>
  <mat-icon fontSet="material-symbols-outlined">{{ icon }}</mat-icon>
</button>
